
import React, { FC, Fragment, useEffect, useState } from 'react';
import { Button, OverlayTrigger, Spinner, Tooltip } from 'react-bootstrap';
import DataTable from 'react-data-table-component';
import { Link } from 'react-router-dom';
import Loader from 'src/utils/Loader';


const Orders = () => {
  const [loading, setLoading] = useState(false);
  

  const tempData = [
    {
      date: 'May 25, 2025',
      amount: '$49.99',
      paymentMethod: 'Stripe',
      transactionId: 'txn_1a2b3c4d',
      subscriptionName: 'Wix',
      status: 'Paid',
      invoice: 'Check Invoice',
    },
    {
      date: 'May 25, 2025',
      amount: '$49.99',
      paymentMethod: 'Stripe',
      transactionId: 'txn_1a2b3c4d',
      subscriptionName: 'Wix',
      status: 'Paid',
      invoice: 'Check Invoice',
    },
    {
      date: 'May 25, 2025',
      amount: '$49.99',
      paymentMethod: 'Stripe',
      transactionId: 'txn_1a2b3c4d',
      subscriptionName: 'Wix',
      status: 'Paid',
      invoice: 'Check Invoice',
    },
    {
      date: 'May 25, 2025',
      amount: '$49.99',
      paymentMethod: 'Stripe',
      transactionId: 'txn_1a2b3c4d',
      subscriptionName: 'Wix',
      status: 'Paid',
      invoice: 'Check Invoice',
    },
    {
      date: 'May 25, 2025',
      amount: '$49.99',
      paymentMethod: 'Stripe',
      transactionId: 'txn_1a2b3c4d',
      subscriptionName: 'Wix',
      status: 'Paid',
      invoice: 'Check Invoice',
    },
    {
      date: 'May 25, 2025',
      amount: '$49.99',
      paymentMethod: 'Stripe',
      transactionId: 'txn_1a2b3c4d',
      subscriptionName: 'Wix',
      status: 'Paid',
      invoice: 'Check Invoice',
    },
    {
      date: 'May 25, 2025',
      amount: '$49.99',
      paymentMethod: 'Stripe',
      transactionId: 'txn_1a2b3c4d',
      subscriptionName: 'Wix',
      status: 'Paid',
      invoice: 'Check Invoice',
    },
    {
      date: 'May 25, 2025',
      amount: '$49.99',
      paymentMethod: 'Stripe',
      transactionId: 'txn_1a2b3c4d',
      subscriptionName: 'Wix',
      status: 'Paid',
      invoice: 'Check Invoice',
    },
    {
      date: 'May 25, 2025',
      amount: '$49.99',
      paymentMethod: 'Stripe',
      transactionId: 'txn_1a2b3c4d',
      subscriptionName: 'Wix',
      status: 'Paid',
      invoice: 'Check Invoice',
    },
    {
      date: 'May 25, 2025',
      amount: '$49.99',
      paymentMethod: 'Stripe',
      transactionId: 'txn_1a2b3c4d',
      subscriptionName: 'Wix',
      status: 'Paid',
      invoice: 'Check Invoice',
    },
    {
      date: 'May 25, 2025',
      amount: '$49.99',
      paymentMethod: 'Stripe',
      transactionId: 'txn_1a2b3c4d',
      subscriptionName: 'Wix',
      status: 'Paid',
      invoice: 'Check Invoice',
    },
    {
      date: 'May 25, 2025',
      amount: '$49.99',
      paymentMethod: 'Stripe',
      transactionId: 'txn_1a2b3c4d',
      subscriptionName: 'Wix',
      status: 'Paid',
      invoice: 'Check Invoice',
    },
    {
      date: 'May 25, 2025',
      amount: '$49.99',
      paymentMethod: 'Stripe',
      transactionId: 'txn_1a2b3c4d',
      subscriptionName: 'Wix',
      status: 'Paid',
      invoice: 'Check Invoice',
    },
    {
      date: 'May 25, 2025',
      amount: '$49.99',
      paymentMethod: 'Stripe',
      transactionId: 'txn_1a2b3c4d',
      subscriptionName: 'Wix',
      status: 'Paid',
      invoice: 'Check Invoice',
    },
    {
      date: 'May 25, 2025',
      amount: '$49.99',
      paymentMethod: 'Stripe',
      transactionId: 'txn_1a2b3c4d',
      subscriptionName: 'Wix',
      status: 'Paid',
      invoice: 'Check Invoice',
    },
    {
      date: 'May 25, 2025',
      amount: '$49.99',
      paymentMethod: 'Stripe',
      transactionId: 'txn_1a2b3c4d',
      subscriptionName: 'Wix',
      status: 'Paid',
      invoice: 'Check Invoice',
    },
    {
      date: 'May 25, 2025',
      amount: '$49.99',
      paymentMethod: 'Stripe',
      transactionId: 'txn_1a2b3c4d',
      subscriptionName: 'Wix',
      status: 'Paid',
      invoice: 'Check Invoice',
    },
    {
      date: 'May 25, 2025',
      amount: '$49.99',
      paymentMethod: 'Stripe',
      transactionId: 'txn_1a2b3c4d',
      subscriptionName: 'Wix',
      status: 'Paid',
      invoice: 'Check Invoice',
    },
    {
      date: 'May 25, 2025',
      amount: '$49.99',
      paymentMethod: 'Stripe',
      transactionId: 'txn_1a2b3c4d',
      subscriptionName: 'Wix',
      status: 'Paid',
      invoice: 'Check Invoice',
    },
    {
      date: 'May 25, 2025',
      amount: '$49.99',
      paymentMethod: 'Stripe',
      transactionId: 'txn_1a2b3c4d',
      subscriptionName: 'Wix',
      status: 'Paid',
      invoice: 'Check Invoice',
    },
    {
      date: 'May 26, 2025',
      amount: '$49.99',
      paymentMethod: 'Stripe',
      transactionId: 'txn_1a2b3c4d',
      subscriptionName: 'Wix',
      status: 'Paid',
      invoice: 'Check Invoice',
    },
    {
      date: 'May 26, 2025',
      amount: '$49.99',
      paymentMethod: 'Stripe',
      transactionId: 'txn_1a2b3c4d',
      subscriptionName: 'Wix',
      status: 'Paid',
      invoice: 'Check Invoice',
    },
    {
      date: 'May 26, 2025',
      amount: '$49.99',
      paymentMethod: 'Stripe',
      transactionId: 'txn_1a2b3c4d',
      subscriptionName: 'Wix',
      status: 'Paid',
      invoice: 'Check Invoice',
    },
    {
      date: 'May 26, 2025',
      amount: '$49.99',
      paymentMethod: 'Stripe',
      transactionId: 'txn_1a2b3c4d',
      subscriptionName: 'Wix',
      status: 'Paid',
      invoice: 'Check Invoice',
    },
    {
      date: 'May 26, 2025',
      amount: '$49.99',
      paymentMethod: 'Stripe',
      transactionId: 'txn_1a2b3c4d',
      subscriptionName: 'Wix',
      status: 'Paid',
      invoice: 'Check Invoice',
    },
    // ... more data here
  ];

  const columns = [
    {
      name: 'Date',
      selector: (row) => row.date,
    },
    {
      name: 'Amount',
      selector: (row) => row.amount,
    },
    {
      name: 'Payment Method',
      selector: (row) => row.paymentMethod,
    },
    {
      name: 'Transaction ID',
      selector: (row) => row.transactionId,
    },
    {
      name: 'Subscription',
      selector: (row) => row.subscriptionName,
    },
    {
      name: 'Status',
      selector: (row) => row.status,
    },
    {
      name: 'Invoice',
      cell: (row) => <Button variant="link"><Link to='/invoice'>{row.invoice}</Link></Button>,
    },
  ];

  return (
    <div>
      <h3>Transaction</h3>
      {tempData == null || loading ? (
        <Loader variant="section" />
      ) : (
        <DataTable
          columns={columns}
          data={tempData}
          pagination
          highlightOnHover
          pointerOnHover
        />
      )}
    </div>
  );
};

export default Orders;
